// Simplified toast component
import { useState, useEffect } from 'react'

type ToastProps = {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

let toastQueue: ToastProps[] = []
let listeners: ((toast: ToastProps) => void)[] = []

export function toast(props: ToastProps) {
  toastQueue.push(props)
  listeners.forEach(listener => listener(props))
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastProps[]>([])

  useEffect(() => {
    const handleNewToast = (toast: ToastProps) => {
      setToasts(prev => [...prev, toast])
      
      // Auto-dismiss after 3 seconds
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t !== toast))
      }, 3000)
    }
    
    listeners.push(handleNewToast)
    
    // Process any queued toasts
    if (toastQueue.length > 0) {
      const queueCopy = [...toastQueue]
      toastQueue = []
      queueCopy.forEach(handleNewToast)
    }
    
    return () => {
      listeners = listeners.filter(listener => listener !== handleNewToast)
    }
  }, [])

  return { toasts }
}
